<div class="spinner spinner-hide">
	<div class="material-loader-wrapper">
		<ngx-spinner type="ball-clip-rotate-pulse" size="default"></ngx-spinner>
	</div>
</div>
